import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-menu" }

import type { HeaderView } from '@/models/header'

import AppMenuItem from './AppMenuItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMenu',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.menuItems, (menuItem, index) => {
      return (_openBlock(), _createBlock(AppMenuItem, {
        key: index,
        icon: menuItem.icon,
        link: menuItem.link,
        text: menuItem.text,
        isActive: __props.view.isItemActive(menuItem)
      }, null, 8, ["icon", "link", "text", "isActive"]))
    }), 128))
  ]))
}
}

})